/**
 * MGA (Monitoreo General Agudos) Pathology Configuration
 *
 * This file contains the complete configuration for the HTA pathology,
 * including modality-specific settings for Protocol and Maintenance modes.
 */

export const MGA_ID = 6; // TODO: id must match the backend

export const mgaConfig = {
  id: MGA_ID,
  name: "MGA",
  displayNameKey: "mga", // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features:
  // surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: [
    "surveys",
    "ecg",
    "howIFeel",
    "configParameters",
    "customizeFrequency",
    "customizeSurveys",
    "customizeHowIFeel",
    "healthData",
  ],

  // Component paths (as strings to avoid circular dependencies)
  // Components can be lazy-loaded when needed
  components: {
    medicalInfoForm: "ModifyMedicalInformationICC",
  },

  // Dashboard-specific configuration
  dashboard: {
    columnSet: 'mga', // MGA-specific columns
    // Export field mappings for CSV/Excel exports
    exportFields: [
      'fullname',
      'antiquity',
      'weekly_adherence',
      'last_data_loaded',
      'hr_today',
      'bp_average_today',
      'oxygen_saturation_today',
      'weight_today',
      'peak_flow_today',
      'body_temperature_today',
      'respiratory_rate_today',
      'face_today',
    ],
    // Custom export transformer (if needed)
    exportTransformer: (row, t) => [
      row.fullname,
      row.antiquity,
      row.weekly_adherence != null ? row.weekly_adherence + '%' : '--',
      row.last_data_loaded ? row.last_data_loaded : '--',
      row.hr_today?.value != null ? row.hr_today.value : '--',
      row.bp_average_today?.value ?? '--',
      row.oxygen_saturation_today?.value != null ? row.oxygen_saturation_today.value : '--',
      row.weight_today?.value != null ? row.weight_today.value : '--',
      row.peak_flow_today?.value != null ? row.peak_flow_today.value : '--',
      row.body_temperature_today?.value != null ? row.body_temperature_today.value : '--',
      row.respiratory_rate_today?.value != null ? row.respiratory_rate_today.value : '--',
      row.face_today ? row.face_today : '--',
    ],
    // Chart configurations - MGA uses same charts as ICC
    charts: [
      "how-i-feel",
      "weight",
      "blood-pressure",
      "heart-rate",
      "oxygen-saturation",
      "blood-glucose",
    ],
  },

  // Patient profile fields to display
  profileFields: {
    weight: true,
    height: true,
    bmi: true,
    bloodPressure: true,
    heartRate: true,
    ejectionFraction: true, // FEVI
  },

  // Alert-specific configuration
  alerts: {
    showHowIFeelColumn: true,
    priorityLevels: [1, 2, 3, 4, 5],
  },
};

export default mgaConfig;
